export const getIsDailyMaxPayoutLimitReached = (
  dailyMaxPayoutLimit: number | undefined,
  totalPotentialReturns: number | undefined
): dailyMaxPayoutLimit is number =>
  !!dailyMaxPayoutLimit &&
  !!totalPotentialReturns &&
  totalPotentialReturns / 100 > dailyMaxPayoutLimit;
